import { Outlet } from 'react-router-dom';

import styled from 'styled-components';

import CoreImg from 'shared/CoreImg';

const LoginLayout = () => {
	return (
		<Background>
			<LoginBox>
				<TitleGroup>
					{/* <CoreImg src={`/wconcept_logo.png`} alt="Wconcept_logo" /> */}
					<img
						src={`/wconcept_logo.png`}
						width={400}
						alt="Wconcept_logo"
						loading="lazy"
					/>
				</TitleGroup>

				<Outlet />
			</LoginBox>
		</Background>
	);
};

const Background = styled.div`
	width: 100%;
	height: 100%;

	${({ theme }) => theme.common.flexCenter};
`;

const LoginBox = styled.div`
	width: 400px;
	margin: 0 16px;
	height: max-content;

	${({ theme }) => theme.common.flexStart};
	flex-direction: column;
	gap: 32px;
`;

const TitleGroup = styled.div`
	& > img {
		border-radius: 8px;
	}
	/* 
	${({ theme }) => theme.device.common(768)`
  display: none;
  `} */
`;

export default LoginLayout;
